<template>
    <div class="category-icon">
        <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M35.8167 36.3244H15.4L11.8222 44.6561C10.9407 46.7066 10.5 48.2379 10.5 49.2502C10.5 50.0548 10.8759 50.7686 11.6278 51.3915C12.4056 51.9885 14.0648 52.3778 16.6056 52.5595V54H0V52.5595C2.2037 52.1702 3.62963 51.664 4.27778 51.0411C5.6 49.7952 7.06481 47.2646 8.67222 43.4492L27.2222 0H28.5833L46.9389 43.9164C48.4167 47.4463 49.7519 49.7433 50.9444 50.8075C52.163 51.8457 53.8481 52.4297 56 52.5595V54H35.1944V52.5595C37.2944 52.4557 38.7074 52.1053 39.4333 51.5083C40.1852 50.9113 40.5611 50.1846 40.5611 49.328C40.5611 48.186 40.0426 46.3821 39.0056 43.9164L35.8167 36.3244ZM34.7278 33.4434L25.7833 12.1081L16.6056 33.4434H34.7278Z"
                :fill="selected ? currentColor : 'none'" :stroke="selected ? 'none' : currentColor" />
        </svg>
        <div v-if="hasText" class="navbar-text-desc">
            <p>typo-graphy</p>
        </div>
    </div>
</template>

<style scoped>
.category-icon {
    width: v-bind(width);
    height: v-bind(height);
    display: flex;
    gap: 14px;
}

svg {
    height: v-bind(height);
}

.navbar-text-desc p {
    width: 40px;
}
</style>

<script setup>
import { useThemeStore } from '@/stores/useThemeStore';
import { computed } from 'vue';

const currentColor = computed(() => (useThemeStore.isDark ? "#E8E8E8" : "#000000"))

const props = defineProps({
    selected: {
        type: Boolean,
        default: false
    },
    hasText: {
        type: Boolean,
        default: false
    },
    width: {
        type: String,
        default: '153px'
    },
    height: {
        type: String,
        default: 'auto'
    }
})
</script>